import React from 'react';

// Some of our global styles are leaking into some DIG
// components. This stylesheet resets a few things.
import './reset.scss';

// Import custom DIG themes and component overrides.
import './theme.scss';
import './overrides.scss';
import './rebrand.scss';

// Import all required DIG helpers and stylesheets.
import 'dig-components';
import 'dig-components/dist/tokens.css';
import 'dig-components/dist/index.web.css';
import 'dig-fonts/dist/index.css';

// Define the HelloSign themes names.
export const helloSignTheme = 'HelloSign';
export const helloSignRebrandTheme = 'HS-Rebrand';

// Define the HelloSign DIG theme classes.
export const helloSignThemeClassName = `dig-theme--${helloSignTheme}`;
export const helloSignRebrandThemeClassName = `dig-theme--${helloSignRebrandTheme}`;

type DigThemeProps = {
  theme: typeof helloSignTheme | typeof helloSignRebrandTheme,
};

export const DigTheme: React.FunctionComponent<DigThemeProps> = ({ theme, children }) => (
  <span className={`dig-theme--${theme}`}>
    {children}
  </span>
);
